module.exports = __webpack_public_path__ + "static/media/teoLogoBlanc.918cdfde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teoLogoBlanc.png
// module id = 1870
// module chunks = 0